import { render, staticRenderFns } from "./formEditBank.vue?vue&type=template&id=327d5236"
import script from "./formEditBank.vue?vue&type=script&lang=js"
export * from "./formEditBank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('327d5236')) {
      api.createRecord('327d5236', component.options)
    } else {
      api.reload('327d5236', component.options)
    }
    module.hot.accept("./formEditBank.vue?vue&type=template&id=327d5236", function () {
      api.rerender('327d5236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/bank/components/form/formEditBank.vue"
export default component.exports